<template>
  <div class="admin-articles">
    <div class="page-header">
      <h2 class="page-title">文章管理</h2>
      <el-button type="primary" icon="el-icon-plus" @click="$router.push('/admin/articles/create')">
        新建文章
      </el-button>
    </div>

    <div class="filter-bar">
      <el-radio-group v-model="statusFilter" size="small" @change="loadArticles">
        <el-radio-button label="">全部</el-radio-button>
        <el-radio-button label="published">已发布</el-radio-button>
        <el-radio-button label="draft">草稿</el-radio-button>
      </el-radio-group>
    </div>

    <el-table :data="articles" v-loading="loading" stripe>
      <el-table-column prop="title" label="标题" min-width="120" />
      <el-table-column prop="status" label="状态" width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 'published' ? 'success' : 'warning'" size="mini">
            {{ scope.row.status === 'published' ? '已发布' : '草稿' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="分类" width="100">
        <template slot-scope="scope">
          {{ scope.row.category ? scope.row.category.name : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="view_count" label="浏览" width="70" />
      <el-table-column label="创建时间" width="110">
        <template slot-scope="scope">
          {{ formatDate(scope.row.created_at) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="300" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="$router.push(`/admin/articles/edit/${scope.row.id}`)">
            编辑
          </el-button>
          <el-button size="mini" :type="scope.row.status === 'draft' ? 'success' : 'warning'"
            @click="toggleStatus(scope.row)">
            {{ scope.row.status === 'draft' ? '发布' : '撤回' }}
          </el-button>
          <el-button size="mini" type="danger" @click="deleteArticle(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-bar" v-if="pagination.pages > 1">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="pagination.total"
        :page-size="pagination.per_page"
        :current-page.sync="pagination.page"
        @current-change="loadArticles"
      />
    </div>
  </div>
</template>

<script>
import { adminApi } from '../../utils/api'

export default {
  name: 'AdminArticles',
  data() {
    return {
      articles: [],
      loading: false,
      statusFilter: '',
      pagination: { page: 1, per_page: 20, total: 0, pages: 0 }
    }
  },
  created() {
    this.loadArticles()
  },
  methods: {
    async loadArticles() {
      this.loading = true
      try {
        const params = { page: this.pagination.page, per_page: this.pagination.per_page }
        if (this.statusFilter) params.status = this.statusFilter
        const res = await adminApi.getArticles(params)
        this.articles = res.articles || []
        this.pagination = res.pagination || this.pagination
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    async toggleStatus(article) {
      const newStatus = article.status === 'draft' ? 'published' : 'draft'
      try {
        await adminApi.updateArticle(article.id, { status: newStatus })
        this.$message.success(newStatus === 'published' ? '文章已发布' : '文章已撤回')
        this.loadArticles()
      } catch (e) {
        this.$message.error('操作失败')
      }
    },
    async deleteArticle(article) {
      try {
        await this.$confirm(`确定删除文章「${article.title}」？`, '确认删除', {
          type: 'warning'
        })
        await adminApi.deleteArticle(article.id)
        this.$message.success('删除成功')
        this.loadArticles()
      } catch (e) {
        if (e !== 'cancel') this.$message.error('删除失败')
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      const d = new Date(dateStr)
      return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`
    }
  }
}
</script>

<style scoped>
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.page-title {
  font-size: 22px;
  font-weight: 600;
  color: #2c3e50;
}
.filter-bar {
  margin-bottom: 16px;
}
.pagination-bar {
  text-align: center;
  padding: 16px 0;
}
</style>
